import { Link, Stack } from '@mui/material';
import { Mail, WhatsApp } from '@mui/icons-material';
import { useTranslation } from '../../contexts/TranslationContext';
import { MHMTypography } from './MHM/MHMTypography';
import { MHMIconButton } from './MHM/MHMIconButton';
import { useIsMobile } from '../../hooks/useIsMobile';

export const FOOTER_HEIGHT = 60;

export function PrivacyAndCookies() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <Link
      href="https://device-service.manhole-metrics.com/redirect-to-privacy-and-cookies"
      color={isMobile ? 'text.primary' : 'appBarText'}
      underline="none"
      textAlign="center"
    >
      {t('Privacy + Cookies')}
    </Link>
  );
}

export function TermsOfUse() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <Link
      href="https://device-service.manhole-metrics.com/redirect-to-terms-of-use"
      color={isMobile ? 'text.primary' : 'appBarText'}
      underline="none"
      textAlign="center"
    >
      {t('Terms Of Use')}
    </Link>
  );
}

export function SupportEmail() {
  const isMobile = useIsMobile();
  return (
    <a href="mailto:support@manholemetrics.com">
      <MHMIconButton color={isMobile ? 'default' : 'appBarText'} sx={{ p: 0 }}>
        <Mail />
      </MHMIconButton>
    </a>
  );
}

export function SupportWhatsApp() {
  const isMobile = useIsMobile();
  return (
    <a href="https://wa.me/02080505393">
      <MHMIconButton color={isMobile ? 'default' : 'appBarText'} sx={{ p: 0 }}>
        <WhatsApp />
      </MHMIconButton>
    </a>
  );
}

export function Support() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <MHMTypography
        color={isMobile ? 'default' : 'appBarText'}
        textAlign="center"
      >
        {t('Support')}:
      </MHMTypography>
      <SupportEmail />
      <SupportWhatsApp />
    </Stack>
  );
}

export function Version() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <MHMTypography
      color={isMobile ? 'text.primary' : 'appBarText'}
      textAlign="center"
    >
      {t('Version') + ' ' + import.meta.env.REACT_APP_VERSION}
    </MHMTypography>
  );
}

export function Footer() {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      bgcolor="appBarBackground.main"
      height={FOOTER_HEIGHT}
      px={2}
      position="fixed"
      bottom={0}
      width="100vw"
      divider={
        <MHMTypography
          color="appBarText.main"
          sx={{
            px: 1,
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
          }}
        >
          ·
        </MHMTypography>
      }
    >
      <PrivacyAndCookies />
      <TermsOfUse />
      <Support />
      <Version />
    </Stack>
  );
}
